import React from 'react';
import { TAILWIND_CLASSES } from '../../Constants/theme';

const Logo = ({ size = 'md', withText = true }) => {
  // Set size class based on prop
  const logoSizeClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12',
    xl: 'h-16',
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
  };

  // SVG for the logo icon (simplified version of the Unisoft logo)
  const LogoIcon = () => (
    <svg 
      className={logoSizeClasses[size]} 
      viewBox="0 0 200 200" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="50%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#ec4899" />
        </linearGradient>
      </defs>
      <path 
        d="M100 20C55.8 20 20 55.8 20 100C20 144.2 55.8 180 100 180C144.2 180 180 144.2 180 100C180 55.8 144.2 20 100 20ZM100 40C133.1 40 160 66.9 160 100C160 133.1 133.1 160 100 160C66.9 160 40 133.1 40 100C40 66.9 66.9 40 100 40Z" 
        fill="url(#logoGradient)"
      />
      <circle cx="100" cy="100" r="20" fill="url(#logoGradient)" />
      <path 
        d="M100 60C77.9 60 60 77.9 60 100C60 122.1 77.9 140 100 140C122.1 140 140 122.1 140 100C140 77.9 122.1 60 100 60ZM100 80C111 80 120 89 120 100C120 111 111 120 100 120C89 120 80 111 80 100C80 89 89 80 100 80Z" 
        fill="url(#logoGradient)"
        fillOpacity="0.6"
      />
    </svg>
  );

  return (
    <div className="flex items-center">
      <LogoIcon />
      {withText && (
        <span className={`${TAILWIND_CLASSES.gradientText} font-bold ml-2 ${textSizeClasses[size]}`}>
          UNISOFT
        </span>
      )}
    </div>
  );
};

export default Logo; 